var React = require('react');

function SmartQuotes (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M30 0.0447939V13.734C16.7367 13.734 14.8685 23.2569 15.5923 28.0184H30V55H6.08538e-05C-0.000149309 51.8258 0.000110216 45.8739 6.08538e-05 26.2328C2.63435 4.60778 21.4474 -0.550389 30 0.0447939Z","key":0}),React.createElement("path",{"d":"M73 0.0447939V13.734C59.7367 13.734 57.8685 23.2569 58.5923 28.0184H73V55H43.0001C42.9999 51.8258 43.0001 45.8739 43.0001 26.2328C45.6344 4.60778 64.4474 -0.550389 73 0.0447939Z","key":1})]);
}

SmartQuotes.defaultProps = {"width":"73","height":"55","viewBox":"0 0 73 55","fill":"auto"};

module.exports = SmartQuotes;

SmartQuotes.default = SmartQuotes;
